type ActivationLoadingViewProps = {
  title: string
  body: string
}

export const ActivationLoadingView = ({ title, body }: ActivationLoadingViewProps) => (
  <div className="flex min-h-[16rem] flex-col items-center justify-center gap-3 text-center">
    <div className="h-7 w-7 animate-spin rounded-full border-2 border-[color-mix(in_srgb,var(--color-border-strong)_65%,transparent)] border-t-transparent" />
    <div className="space-y-1">
      <h2 className="text-lg font-semibold tracking-tight text-(--color-text-primary)">{title}</h2>
      <p className="text-sm leading-relaxed text-(--color-text-secondary)">{body}</p>
    </div>
  </div>
)
